// this is an object that we can change as we need

const glStyles = {
  card: {
    boxShadow: "0 0.5rem 1.2rem rgb(189 197 209 / 20%)",
    backgroundColor: "white",
    border: "1px solid #e7eaf3",
    borderRadius: "0.5rem",
    fontSize: "16px",
    color: "#1F3947",
  },
};
export default glStyles;
